<template>
  <div>
    <b-card no-body>
      <b-card-body class="p-4">
        <h1>Checkout Successful</h1>
        <p class="text-muted mt-3">You have successfully checkout your cart. Thank you for you submission(s). A representative will contact you shortly.</p>
        <b-button variant="success" block @click="toDashboard">Click to view instructions on how to send your sample</b-button>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  export default {
    name: 'CartCheckoutSuccess',
    data() {
      return {}
    },
    methods: {
      toDashboard: function() {
        this.$router.push('/instructions');
      }
    }
  }
</script>
